/**
 * Return boolean {false}
 *
 * @param {delay} The delay time in milliseconds (eg. 1000)
 */
export function setSmoothLoading(delay) {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve(false);
        }, delay);
    });
}
//# sourceMappingURL=loading.js.map